// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Growth_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.75 19.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 1.5 0v10.19l4.72-4.72a.75.75 0 0 1 1.06 0L12 12.44l4.94-4.94H15A.75.75 0 0 1 15 6h3.75a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V8.56l-5.47 5.47a.75.75 0 0 1-1.06 0L9 11.56l-5.25 5.25v1.94H21a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Growth_Stroke2_Corner0_Rounded',
})
